import { formatAddress } from "encamp-shared/src/utils/address";
import { compact } from "lodash-es";

type FacilityAddress = {
  streetAddress1?: string | null;
  streetAddress2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
};

/**
 * A facility's address as mailing-label lines: the street on one line and
 * "City, ST 12345" on the next. Joining every part with spaces made it
 * impossible to tell where the street ended and the city began. Empty lines
 * are dropped.
 */
export function facilityAddressLines({
  streetAddress1,
  streetAddress2,
  city,
  state,
  zip,
}: FacilityAddress): string[] {
  const street = compact([streetAddress1?.trim(), streetAddress2?.trim()]).join(", ");
  const locality = formatAddress(null, city, state, zip);
  return compact([street, locality]);
}
